import { render, staticRenderFns } from "./OfficialHolidayAdd.vue?vue&type=template&id=73baf61a&scoped=true&"
import script from "./OfficialHolidayAdd.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidayAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73baf61a",
  null
  
)

export default component.exports